import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import GenericSurepassOutputComponent from '../output/GenericSurepassOutputComponent';

const EsignGetReportInputComponent = () => (
    <SimpleReportForm
        banner={{ icon: 'pi-pencil', title: 'E-Sign Get Report', subtitle: 'Fetch consolidated e-sign report by categories (comma-separated)' }}
        fields={[
            { name: 'categories', label: 'Categories', icon: 'pi-tag', placeholder: 'name_match, dob_match', maxLength: 200, default: 'name_match',
              colClass: 'col-12 md:col-8 lg:col-6' },
        ]}
        endpoint={{
            path: '/surepass/esign/get-report',
            bodyMapper: (v, sid) => ({
                categories: v.categories.trim().split(',').map((c) => c.trim()).filter(Boolean),
                api_provider_service_id: parseInt(sid, 10),
            }),
        }}
        consentReportType="esign-get-report"
        submitLabel="Fetch Report"
        successSummary="E-sign report fetched"
        errorSummary="E-sign report failed"
        confirmHeader="Confirm e-sign report fetch"
        confirmAcceptLabel="Yes, fetch"
        outputComponent={GenericSurepassOutputComponent}
        outputProps={{ title: 'E-Sign Report', icon: 'pi-pencil' }}
    />
);

export default EsignGetReportInputComponent;
